
import { Component, Mixins, Watch, PropSync, Prop } from 'vue-property-decorator';
import { VuetifyMixin, BAIconsMixin, StringsMixin } from '@/mixins';
import { CoachProfileModel } from '@/models';
import { coachApi } from '@/api/CoachApi';
import { DebounceMixin } from '@/mixins';
import { QueryOptions, RepositoryQuery } from '@/../types';

@Component
export default class AdminCoachAutocomplete extends Mixins(DebounceMixin, VuetifyMixin, BAIconsMixin, StringsMixin){
	@PropSync('value') coach: CoachProfileModel | null;
	@Prop({ default: "Select Coach" }) label: string;
	@Prop({ default: "Start typing to search" }) placeholder: string;
	@Prop({ default: 10 }) limit: number;
	@Prop() initialSearch: string;
	@Prop({ type: Boolean }) loading;
	@Prop({ type: Boolean }) disabled;
	@Prop({ default: 20 }) avatarSize: number;
	@Prop({ type: Boolean }) showId;
	@Prop({ type: Boolean }) showDeleted;

	coaches: Array<CoachProfileModel> = [];
	numCoaches: number = 0;
	search: string = "";
	searchLoading: boolean = false;
	@Watch('search') debounceSearchCoaches() {
		this.searchLoading = true;
		this.debounceCallback('searchCoaches', this.searchCoaches.bind(this), 500);
	}

	onValueChanged(newVal) {
		this.$emit('coachChange', newVal);
	}
	async searchCoaches(): Promise<void>{
		this.searchLoading = true;
		try {
			const query: RepositoryQuery<CoachProfileModel> = {
				search: this.search,
				fields: [
					'id',
					'firstName',
					'lastName',
					'email',
					'tags',
				]
			}
			// query.$match = {...query.$match, ...{ deleted: this.showDeleted? true : {$any:[false, undefined, null]} }};
			
			const options: QueryOptions = {limitPerPage: this.limit};
			const response = await coachApi.queryAll(query, options);
			this.numCoaches = response.total;
			this.coaches = response.docs;
		} catch(e) {
			console.error('Failed to query coaches', e);
		}

		this.searchLoading = false;
	}
}
